import { TOPUP_STATUS } from '../components/products/Wallet/constant';
import serviceToken from './requestToken';
// const DSZ_API = process.env.REACT_APP_API_URL_DSZ;
// const DSZ_BASE_API = DSZ_API + 'rp/';
const RETAILER_BASE_API = process.env.REACT_APP_RETAILER_BASE_API;

export const getVerifyingPaymentsSvc = async () => {
  const res = await serviceToken.get(
    RETAILER_BASE_API + '/history/credit-recharge',
    {
      params: {
        status: TOPUP_STATUS.PENDING,
        is_count_query: true
      }
    }
  );

  return res.data;
};

// params: {month: string, sources: string[],status: string[], page: number, limit: number, is_count_query: boolean}
export const getRechargeHistorySvc = async (params = {}) => {
  const res = await serviceToken.get(
    RETAILER_BASE_API + '/history/credit-recharge',
    {
      params: {
        ...params,
        is_count_query: false
      }
    }
  );

  return res.data;
};

export const getRechargeHistoryByIdSvc = async (id) => {
  const res = await serviceToken.get(
    RETAILER_BASE_API + `/history/credit-recharge/${id}`
  );

  return res.data;
};

export const getUsedHistorySvc = async (params = {}) => {
  const res = await serviceToken.get(
    RETAILER_BASE_API + '/history/credit-use',
    {
      params: {
        ...params,
        is_count_query: false
      }
    }
  );

  return res.data;
};
